export default __webpack_public_path__ + "static/media/mamakit.3cb25998.png";